export default {
  setExportLoading(state, exportLoading) {
    state.exportLoading = exportLoading;
  },
  setLoading(state, loading) {
    state.loading = loading;
  },
  setLogsUser(state, logsUser) {
    state.logsUser = logsUser;
  },
  setTotalLogsUser(state, totalLogsUser) {
    state.totalLogsUser = totalLogsUser;
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-analytic/features/logs/pages/user/store/mutations.js